export default "__VITE_ASSET__d2d2e1d8__"